import React from 'react';

import OptimizeDetailsTable from '@totem/components/services/optimize/v1/optimizeDetailsTable';

// Reused verbatim — the same component v1 and v2 both already share.
const OptimizeOpportunitiesTab = () => <OptimizeDetailsTable />;

export default OptimizeOpportunitiesTab;
